import Component from '../../colorz/Component';

export default class TrackingCart extends Component {
	/**
	 * Initialise.
	 */
	onInit(el) {
		this.cart = el;
		this.cartSampleItem = this.cart.querySelectorAll('.cart-free-item');
		this.cartNote = this.cart.querySelector('#Cart-note');
		this.hasFocusedAndTyped = false; // Ajouter un indicateur pour suivre l'état du focus
	}

	onReady() {
		this.cartNote && this.handleCartNoteEvent();
	}

	onLoad() {}

	/**
	 * Handle cart note event.
	 */
	handleCartNoteEvent() {
		// Ajoute un DL lorsque l'élement est focus.
		this.cartNote.addEventListener('focus', () => {
			this.cartNote.addEventListener('input', () => {
				if (!this.hasFocusedAndTyped && this.cartNote.value.length > 0) {
					const dataLayerAddGiftMessage = {
						event: 'add_gift_message',
					};
					window.dataLayer.push(dataLayerAddGiftMessage);
					this.hasFocusedAndTyped = true; // Mettre à jour l'indicateur pour éviter les futurs push
				}
			});
		});
	}

	/**
	 * Handle cart sample event.
	 */
	// handleCartSampleEvent() {
	// 	if (this.cartSampleItems && this.cartSampleItems.length > 0) {
	// 		this.cartSampleItems.forEach((element) => {
	// 			const checkbox = element.querySelector('input[type="checkbox"]');
	// 			if (checkbox) {
	// 				checkbox.addEventListener('change', () => {
	// 					if (checkbox.checked) {
	// 						const sampleTitle = element.dataset.sampleTitle;
	// 						const dataLayerAddSample = {
	// 							event: 'choose_sample',
	// 							item_name: sampleTitle,
	// 						};
	// 						window.dataLayer.push(dataLayerAddSample);
	// 					}
	// 				});
	// 			}
	// 		});
	// 	} else {
	// 		console.log('No cart sample items found.');
	// 	}
	// }
}
